// Hardcoded issuer details (Hailio (Pty) Ltd — the practice issuing invoices).
// REBRANDED Motaoana Investments → Hailio (2026-06-27). Fields marked "TODO — Hailio …"
// MUST be filled with Hailio's real details BEFORE issuing any invoice: a tax invoice
// that names Hailio but carries the wrong banking/tax details is invalid and could
// misdirect payment. Verify the reg number against the Hailio CIPC certificate and the
// banking block against a Hailio bank confirmation letter.

export const ISSUER = {
  name: "HAILIO (PTY) LTD",
  tradingAs: "Hailio",
  regNumber: "2025/961519/07", // verified against CIPC COR14.3 (issued 2025-12-17)
  taxNumber: "9113458294", // income tax reference — CIPC COR14.3
  vatNumber: null, // Hailio is NOT VAT registered (no VAT number on the CIPC record)
  email: "", // TODO: set Hailio's invoice email (not on the CIPC/bank docs) — blank hides it on invoices
  director: "Matsieng Zablon Mosala", // Hailio director (co-director: Mohau Emmanuel Maluka)
  address: {
    line1: "B3 Carlswald Office Park",
    line2: "1 Seventh Road",
    suburb: "Carlswald",
    province: "Gauteng",
    postalCode: "1684",
    country: "South Africa",
  },
};

export const BANKING = {
  bankName: "Standard Bank",
  accountHolder: "Hailio", // per Standard Bank confirmation letter (2026-01-22)
  accountNumber: "0000010267110616",
  accountType: "Current",
  branch: "Midrand",
  branchCode: "051001",
  swift: "SBZAZAJJ",
};

// Predefined services. Editable per-line at invoice time. Adding a custom line is supported.
export const SERVICE_CATALOG = [
  { code: "BOOKKEEPING", label: "Monthly Bookkeeping", defaultRate: 200, unit: "hour" },
  { code: "TAX_RETURNS", label: "Submission of Tax Returns", defaultRate: 200, unit: "hour" },
];

export const VAT_RATE = 0.15;

export function formatAddress(addr) {
  if (!addr) return "";
  return [addr.line1, addr.line2, addr.suburb, addr.province, addr.postalCode, addr.country]
    .filter((s) => s && String(s).trim())
    .join(", ");
}
